import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const LOCALES = {
  EN: 'en'
}

import en from './en.json';

const messages = {
  [LOCALES.EN]: en
};

const numberFormats = {
  [LOCALES.EN]: {
    currency: {
      style: 'currency', currency: 'USD'
    }
  }
}

const defaultLocale = process.env.VUE_APP_I18N_LOCALE || LOCALES.EN;

export default new VueI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages,
  numberFormats
})